import {
  SIGNUP_CLOSE_POPUP,
  SIGNUP_OPEN_SUCCESS,
  SIGNUP_OPEN_FAIL,
  SIGNUP_OPEN_NOTI,
} from "./types";

export const signupClosePopup = (payload) => {
  return {
    type: SIGNUP_CLOSE_POPUP,
    payload: payload,
  };
};

export const signupOpenSuccess = () => {
  return {
    type: SIGNUP_OPEN_SUCCESS,
  };
};

export const signupOpenFail = () => {
  return {
    type: SIGNUP_OPEN_FAIL,
  };
};

export const signupOpenNoti = (payload) => {
  if (typeof payload === "undefined") {
    payload = true;
  }
  return {
    type: SIGNUP_OPEN_NOTI,
    payload: payload,
  };
};
